import { Kettle } from '@execonline-inc/kettle.private';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import ReqHlsVideo from '../../../../ReqHlsVideo';
import { ReqHlsVideoAssetResource } from '../../../../ReqHlsVideo/Types';
import {
  ExperienceDetailResource,
  ExperienceResource,
} from '../CurrentCollectionStep/BuilderV2/Types';
import ExperienceVideoDetailsModalBody from './ExperienceVideoDetailsModalBody';

interface Props {
  video: ReqHlsVideoAssetResource;
  experienceResource: ExperienceResource;
  experienceDetailResource: ExperienceDetailResource;
  hideEnrollAction?: boolean;
}

function VideoModal({
  video,
  experienceResource,
  experienceDetailResource,
  hideEnrollAction,
}: Props) {
  return (
    <>
      <div className="-mt-14 flex-grow">
        <ReqHlsVideo
          id={video.payload.uuid}
          className="embedded-video"
          videoResource={video}
          kettle={new Kettle()}
          width={'100%'}
          height={'100%'}
          dynamicallySetAspectRatio={true}
        >
          {{
            playButton: nothing(),
          }}
        </ReqHlsVideo>
      </div>
      <div className="relative sm:w-[19.875rem]">
        <ExperienceVideoDetailsModalBody
          experienceResource={experienceResource}
          experienceDetailResource={experienceDetailResource}
          hideEnrollAction={hideEnrollAction}
        />
      </div>
    </>
  );
}

export default observer(VideoModal);
